<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" @click.self="$emit('close')">
    <div class="bg-[#FFFBFC] rounded-lg shadow-lg p-8 w-full max-w-md relative mx-4 flex flex-col">
      <button class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl" @click="$emit('close')">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <h2 class="font-semibold text-xl mb-6 text-gray-900">Agregar Llamada</h2>
      
      <form class="w-full space-y-4" @submit.prevent="save()">
        <div v-if="errors.submit" class="p-3 bg-red-100 border border-red-400 text-red-700 rounded-md text-sm">
          {{ errors.submit }}
        </div>

        <div>
          <label for="task-subject" class="block text-sm font-medium text-custom_gray mb-1">Asunto</label>
          <input
            id="task-subject"
            v-model="subject"
            type="text"
            class="w-full px-3 py-2 border rounded-md focus:ring-tuin-100 focus:border-tuin-100"
            :class="errors.subject ? 'border border-red-500 bg-red-50' : 'border-gray-200'"
            placeholder="Ingresa el asunto de la llamada"
          >
          <p v-if="errors.subject" class="text-sm font-medium text-red-600 mt-1">{{ errors.subject }}</p>
        </div>
        
        <div>
          <label for="task-detail" class="block text-sm font-medium text-custom_gray mb-1">Detalle</label>
          <textarea
            id="task-detail"
            v-model="detail"
            rows="3"
            class="w-full h-32 px-3 py-2 border rounded-md focus:ring-tuin-100 focus:border-tuin-100"
            :class="errors.detail ? 'border border-red-500 bg-red-50' : 'border-gray-200'"
            placeholder="Ingresa el detalle de la llamada"
          ></textarea>
          <p v-if="errors.detail" class="text-sm font-medium text-red-600 mt-1">{{ errors.detail }}</p>
        </div>
        
        <div>
          <label for="task-date" class="block text-sm font-medium text-custom_gray mb-1">Fecha</label>
          <VueDatePicker
            v-model="date"
            :enable-time-picker="false"
            :locale="es"
            class="w-full"
            position="left"
          />
          <p v-if="errors.date" class="text-sm font-medium text-red-600 mt-1">{{ errors.date }}</p>
        </div>
        
        <div class="flex justify-end space-x-3 pt-4">
          <button
            type="submit"
            class="w-full font-medium px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            :disabled="isLoading"
          >
            {{ isLoading ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import { es } from "date-fns/locale";
import { format } from "date-fns";
import VueDatePicker from "@vuepic/vue-datepicker";
import axios from "axios";
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const session = computed(() => store.getters.getUserSession);
const props = defineProps({
  leadId: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(['call-saved', 'close']);

let detail = ref(props.calls?.detail || '');
let subject = ref(props.calls?.subject || '');
let date = ref("");
let isLoading = ref(false);
let errors = ref({});

function validateForm() {
  errors.value = {};
  
  if (!subject.value?.trim()) {
    errors.value.subject = "El asunto es requerido";
  }
  
  if (!detail.value?.trim()) {
    errors.value.detail = "El detalle es requerido";
  }
  
  if (!date.value) {
    errors.value.date = "La fecha es requerida";
  }
  
  return Object.keys(errors.value).length === 0;
}

function formatDate(dateValue) {
  if (!dateValue) return null;
  try {
    return format(new Date(dateValue), 'yyyy-MM-dd');
  } catch (error) {
    console.error('Error al formatear fecha:', error);
    return null;
  }
}

async function save() {
  if (!validateForm()) {
    return;
  }

  if (isLoading.value) return;

  isLoading.value = true;

  const form_post = {
    lead_id: props.leadId,
    subject: subject.value.trim(),
    detail: detail.value.trim(),
    call_date: formatDate(date.value),
  };

  const options = {
    headers: {
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  const url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/add/call`;

  try {
    const response = await axios.post(url_link, form_post, options);

    if (response.status === 200) {
      
      // Limpiar formulario
      detail.value = '';
      subject.value = '';
      date.value = '';
      errors.value = {};
      
      // Emitir evento y cerrar modal
      emit('call-saved', response.data);
      emit('close');
    }
  } catch (error) {
    //console.error("Error al guardar la nota:", error);
  } finally {
    isLoading.value = false;
  }
}

</script>
<style scoped>
:deep(.dp__theme_light) {
  --dp-background-color: #fff;
  --dp-text-color: #737373;
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #737373;
  --dp-hover-icon-color: #737373;
  --dp-primary-color: #FF4265;
  --dp-primary-disabled-color: #6bacea;
  --dp-primary-text-color: #f8f5f5;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: #ddd;
  --dp-menu-border-color: #ddd;
  --dp-border-color-hover: #FF4265;
  --dp-border-color-focus: #FF4265;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #737373;
  --dp-success-color: #76d275;
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #737373;
  --dp-danger-color: #ff6f60;
  --dp-marker-color: #ff6f60;
  --dp-tooltip-color: #fafafa;
  --dp-disabled-color-text: #8e8e8e;
  --dp-highlight-color: rgb(25, 118, 210);
  --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
  --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
  --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
  --dp-input-padding: 9px 42px 9px 16px; /*Padding in the input*/
  --dp-border-radius: 8px; /*Configurable border-radius*/
}
</style>